import { createReducer, createFeature, on } from '@ngrx/store';
import { MappedArea } from 'src/objects/mapped-area';
import { MappedAreaActions } from '../actions';

export interface State {
  mappedArea: MappedArea | null;
  mappedAreaLoading: boolean;

  mappedAreas: MappedArea[] | null;
  mappedAreasLoading: boolean;

  error: Error | null;
}

export const initialState: State = {
  mappedArea: null,
  mappedAreaLoading: false,

  mappedAreas: null,
  mappedAreasLoading: false,

  error: null,
};

export const mappedAreaFeature = createFeature({
  name: 'mappedArea',
  reducer: createReducer(
    initialState,

    on(MappedAreaActions.setMappedArea, (state, { mappedArea })=> ({ ...state, mappedArea })),

    on(MappedAreaActions.loadMappedArea, state => ({ ...state, mappedAreaLoading: true, mappedArea: null, error: null })),
    on(MappedAreaActions.loadMappedAreaSuccess, (state, { mappedArea }) => ({ ...state, mappedAreaLoading: false, mappedArea, error: null })),
    on(MappedAreaActions.loadMappedAreaFailure, (state, { error }) => ({ ...state, mappedAreaLoading: false, mappedArea: null, error })),

    on(MappedAreaActions.loadMappedAreas,
      state => ({ ...state, mappedAreasLoading: true, mappedAreas: null, mappedArea: null, error: null })),
    on(MappedAreaActions.loadMappedAreasSuccess,
      (state, { mappedAreas }) => ({
        ...state,
        mappedAreasLoading: false,
        mappedAreas,
        // TODO: THIS IS A MOTHER-FUCKING-HACK TO SUPPORT DELIVERY AREAS. WE HAVE TO FIX IT
        // TODO: REMOVE THIS SHIT ASAP
        mappedArea: (mappedAreas[0] ?? { id: -666 }) as MappedArea,
        error: null,
    })),
    on(MappedAreaActions.loadMappedAreasFailure, (state, { error }) => ({ ...state, mappedAreasLoading: false, mappedAreas: null, error })),
  ),
});

export const {
  name: mappedAreaFeatureKey,
  reducer,
  selectMappedAreaState,
  selectMappedArea,
  selectMappedAreas,
  selectMappedAreaLoading,
  selectMappedAreasLoading,
  selectError: selectMappedAreaError,
} = mappedAreaFeature;
